import React, {Component}  from 'react';
import {Route, Switch} from 'react-router-dom';

/** 打标签 */
import { view as QuestionExport } from './question_export'
class QuestionBox extends Component{
    render(){
        return(
            <div style={{paddingLeft:'10px',fontSize:0,marginRight:'10px',paddingTop:'10px',minHeight: '100%'}}>
                <div>
                    <Switch>

                        <Route exact path="/questionmanage/questionExport" component={QuestionExport}/>
                    </Switch>
                </div>
            </div>
        );
    }
}
export default QuestionBox



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_export/view.js